import { TMakePhoneCallParams } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';

export const makePhoneCall = async (params: TMakePhoneCallParams) => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
